import React from 'react';
import { Alert } from 'reactstrap';
import { TimesheetStatus } from '../timesheet/Timesheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { hasAnyAdjustmentData } from './CrewTimesheet';

export default class AdjustmentLockoutIndicator extends React.Component {
    render() {
        const { timesheet, isAdmin } = this.props;

        if (
            isAdmin ||
            timesheet.timesheetStatusId >= TimesheetStatus.Submitted ||
            !hasAnyAdjustmentData(timesheet)
        ) {
            return null;
        }

        return (
            <Alert fade={false} color="info" className="d-flex h5">
                <div className="mr-2">
                    <FontAwesomeIcon icon={faLock} />
                </div>
                <div>
                    This timesheet has been adjusted by an elevated user; only
                    an elevated user may make further changes.
                </div>
            </Alert>
        );
    }
}
